// @flow

import * as React from 'react';

import {motion, AnimatePresence} from 'framer-motion';

type FadeInPaneProps = {|
  children: React.Node,
  isRemovedWithoutFade?: boolean,
  isVisible: boolean,
|};

export const FadeInPane = ({
  children,
  isVisible,
  isRemovedWithoutFade,
}: FadeInPaneProps) => {
  return !isRemovedWithoutFade ? (
    <AnimatePresence initial>
      {isVisible ? (
        <motion.div
          key="pane"
          // Why do we transition between relative and absolute positioning?
          // Well, when we position the transition absolutely the component will be on top of any sibling components,
          // giving a nice overlay when we do our animations. However after the animation we want our height to
          // be relative to the parent's height so we don't have any unexpected scrolling.
          initial={{opacity: 0, position: 'absolute'}}
          animate={{
            opacity: 1,
            transitionEnd: {
              position: 'relative',
            },
          }}
          exit={{opacity: 0, position: 'absolute'}}
          style={{
            background: 'white',
            height: '100%',
            width: '100%',
            // This needs to be underneath search result, which sets zIndex = 300.
            zIndex: 201,
          }}
        >
          {children}
        </motion.div>
      ) : null}
    </AnimatePresence>
  ) : null;
};
